import { View } from 'product-list/types/View'

export function isView(view: string | null): view is View {
	return Object.values(View).includes(view as View)
}
